import React, { Fragment, useState, lazy, Suspense } from "react";
import { FormGroup, Input, Listview, Button } from "@mobiscroll/react";
import mobiscroll from "@mobiscroll/react";
import attachmentIcon from "src/assets/Attachment-icon.svg";
import useQuery from "src/lib/useQuery";
import { useStore } from "../store/Store";
import { handleConsultationPopupChange } from "../store/PatientDetailsReducer";
import { listSymptoms } from "../api";

// const ConsultationPopup = lazy(() => import("./Modals/ConsultationPopup"));
const ConsultationPopup = lazy(() => import("../dialogs/SymptomsPopup"));

const options = { weekday: "long", year: "numeric", month: "long", day: "numeric", };

let img_fm = [".tif", ".tiff", ".jpg", ".jpeg", ".gif", ".png", ".eps", ".raw", ".cr2", ".nef", ".orf", ".sr2", ".bmp", ".ppm", ".heif",];
let vid_fm = [".flv", ".avi", ".mp4", ".3gp", ".mov", ".webm", ".ogg", ".qt", ".avchd",];
let aud_fm = [".flac", ".mp3", ".wav", ".wma", ".aac"];

const AvatarItem = ({ item }) => {
  const { question, textDescription } = item;
  const [videoDescription, setVideoDescription] = useState(null);
  const [imgDescription, setImgDescription] = useState(null);
  const [audioDescription, setAudioDescription] = useState(null);
  const [pdfDescription, setPDFDescription] = useState(null);

  // React.useEffect(() => {
  //   if (item.mediaDescription.length) {
  //     item.mediaDescription.map((media) => {
  //       const getFileExtention = (fileUrl) => {
  //         // To get the file extension
  //         return /[.]/.exec(fileUrl)
  //           ? /\.\w{3,4}($|\?)/.exec(fileUrl)
  //           : undefined;
  //       };
  //       let file_ext = getFileExtention(media);
  //       if (file_ext != null) {
  //         file_ext = file_ext[0];
  //         file_ext = file_ext.split("?")[0];
  //       }

  //       if (img_fm.filter((ext) => ext == file_ext).length > 0) {
  //         setImgDescription(media);
  //       } else if (vid_fm.filter((ext) => ext == file_ext).length > 0) {
  //         setVideoDescription(media);
  //       } else if (aud_fm.filter((ext) => ext == file_ext).length > 0) {
  //         setAudioDescription(media);
  //       } else {
  //         setPDFDescription(media);
  //       }
  //     });
  //   }
  // }, []);

  // NEW (FIXED):
  React.useEffect(() => {
    // Initialize all media descriptions
    let foundImage = null;
    let foundVideo = null;
    let foundAudio = null;
    let foundPDF = null;

    if (item.mediaDescription && item.mediaDescription.length > 0) {
      item.mediaDescription.forEach((media) => {  // ✅ Use forEach for side effects
        const getFileExtention = (fileUrl) => {
          return /[.]/.exec(fileUrl)
            ? /\.\w{3,4}($|\?)/.exec(fileUrl)
            : undefined;
        };

        let file_ext = getFileExtention(media);
        if (file_ext != null) {
          file_ext = file_ext[0];
          file_ext = file_ext.toLowerCase();  // ✅ Make case-insensitive
          file_ext = file_ext.split("?")[0];
        }

        // Set the first match found
        if (!foundImage && img_fm.includes(file_ext)) {
          foundImage = media;
        } else if (!foundVideo && vid_fm.includes(file_ext)) {
          foundVideo = media;
        } else if (!foundAudio && aud_fm.includes(file_ext)) {
          foundAudio = media;
        } else if (!foundPDF) {
          foundPDF = media;
        }
      });
    }

    // Update state once after loop
    if (foundImage) setImgDescription(foundImage);
    if (foundVideo) setVideoDescription(foundVideo);
    if (foundAudio) setAudioDescription(foundAudio);
    if (foundPDF) setPDFDescription(foundPDF);
  }, [item]);

  return (
    <>
      <div className="card-1">
        <li className="item-left">
          <h3><b>Q. Which Symptoms are bothering you the most?</b></h3>
        </li>

        <li className="item-right">
          <h3>
            A. {textDescription}

            <br />
            <br />

            <b>
              {videoDescription || audioDescription || imgDescription || pdfDescription ? "Find the below Attachments:" : ""}
            </b>
          </h3>


          <div className="d-flex flex-column">
            {videoDescription && (
              <video width="320" height="240" controls>
                <source src={videoDescription} />
                Your browser does not support the video tag.
              </video>
            )}
            {audioDescription && (
              <audio width="320" height="240" controls>
                <source src={audioDescription} />
                Your browser does not support the video tag.
              </audio>
            )}
            {imgDescription && (
              <img
                className="w-3"
                style={{ maxWidth: "100px" }}
                src={imgDescription}
                alt=""
              />
            )}
            {pdfDescription && (
              <a className="d-flex" target="_blank" href={pdfDescription}>
                PDF:{" "}
                <img
                  className="w-3"
                  style={{ maxWidth: "30px" }}
                  src={attachmentIcon}
                  alt=""
                />
              </a>
            )}
          </div>
        </li>
      </div>
    </>
  );
};

export const Symptom = ({ data, open }) => {
  const [isOpen, setIsOpen] = React.useState(open !== false);

  return (
    <>
      <div className="mt-2" style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <mobiscroll.Accordion className="p-0">
          <mobiscroll.FormGroup collapsible open={isOpen} onOpen={() => setIsOpen(true)}>
            <mobiscroll.FormGroupContent style={{ maxHeight: "50vh", overflowY: "auto" }}>
              <Listview
                itemType={AvatarItem}
                data={data}
                className="docg-message-list"
                enhance={true}
                actionable={false}
                swipe={false}
                sortable={false}  // ✅ Disable sortable to prevent scroll issues
              />
            </mobiscroll.FormGroupContent>
          </mobiscroll.FormGroup>
        </mobiscroll.Accordion>
      </div>
    </>
  );
};

const SymptomTab = (props) => {
  const query = useQuery();

  const { globalState = null, dispatch = null } = useStore() || {};

  const [data, setData] = React.useState(null);
  const [appointmentId, setAppointmentId] = useState(null);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    // const fetchSymptomData = async () => {
    //   try {
    //     if (globalState != null && globalState?.startingConsultation) {
    //       let appointmentId = query.get("appointmentId");
    //       if (appointmentId) {
    //         const res = await listSymptoms(appointmentId);
    //         setData(res);
    //       }
    //     }
    //   } catch (error) {
    //     console.error("Error fetching symptoms:", error);
    //     setData(null);
    //   }
    // };

    const fetchSymptomData = async () => {
      try {
        setError(null);  // ✅ Clear previous errors

        if (globalState != null && globalState?.startingConsultation) {
          let appointmentId = query.get("appointmentId");

          if (!appointmentId) {
            setError("No appointment ID found");
            setData(null);
            return;
          }

          const res = await listSymptoms(appointmentId);

          // ✅ Check if response is valid
          if (!res) {
            setError("No response from server");
            setData(null);
            return;
          }

          // ✅ Verify it has the expected structure
          if (!res.survey || !res.survey.questions) {
            console.warn("Unexpected API response structure:", res);
            setError("Invalid response structure from server");
            setData(null);
            return;
          }

          setData(res);  // ✅ Data is: { survey: { questions: [...] }, start: "..." }
        }
      } catch (error) {
        console.error("Error fetching symptoms:", error);
        setError(error.message || "Failed to load symptoms");
        setData(null);
      }
    };

    fetchSymptomData();
  }, [globalState?.startingConsultation, query]);

  React.useEffect(() => {
    if (globalState != null && !globalState?.startingConsultation) {
      dispatch(handleConsultationPopupChange(false));
    }
  }, [globalState?.startingConsultation, dispatch]);

  if (globalState?.showConsultation && data === null) {
    return (
      <Suspense fallback={<div>Loading...</div>}>
        <ConsultationPopup />
      </Suspense>
    );
  }

  return (
    <div className="">
      {/* Show error message if error occurred */}
      {error && (
        <div className="alert alert-danger" role="alert" style={{ margin: "10px" }}>
          <strong>Error:</strong> {error}
        </div>
      )}

      {/* Show symptoms data if available */}
      {data != null && !error && (
        <Symptom data={data?.survey?.questions} open={true} />
      )}

      {/* Show empty state only if no error and no data */}
      {data === null && !error && !globalState?.showConsultation && (
        <div className="p-3 text-center" style={{ color: "#999" }}>
          <p>No symptoms data available</p>
        </div>
      )}
    </div>
  );
};

export default SymptomTab;
